import React, { MouseEvent, forwardRef } from 'react';
import { getIcon, getRequiredLabel } from '../jdsinputfield/logic';

import type { JDSInputFieldV2Props } from './generated/interface';

interface InputFieldV2Props
  extends Omit<
    JDSInputFieldV2Props,
    | 'onChange'
    | 'onPrefixClick'
    | 'onSuffixClick'
    | 'onFocus'
    | 'onBlur'
    | 'onInvalid'
  > {
  onFocus?: React.HTMLAttributes<HTMLInputElement>['onFocus'];
  onBlur?: React.HTMLAttributes<HTMLInputElement>['onBlur'];
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  onPrefixClick?: (ev: MouseEvent<HTMLDivElement>) => void;
  onSuffixClick?: (value: MouseEvent<HTMLDivElement>) => void;
  onInvalid?: (ev: React.InvalidEvent<HTMLInputElement>) => void;
}

export const withLogic = (
  Component: React.ComponentType<
    InputFieldV2Props & { ref?: React.Ref<HTMLInputElement> }
  >
): React.FC<InputFieldV2Props> => {
  return forwardRef<HTMLInputElement, InputFieldV2Props>(
    (props: InputFieldV2Props, ref) => {
      return (
        <Component
          {...{ ...props, layerRefs: { input: ref } }}
          prefix={getIcon(props.prefix)}
          suffix={getIcon(props.suffix)}
          label={getRequiredLabel(props.label, props.required)}
          _hasDynamic={Boolean(props.dynamicText || props.dynamicButtonText)}
          _noPrefix={!props.prefix}
        />
      );
    }
  );
};

export { InputFieldV2Props };
